// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"f7fe6","checkbox":"_4b0fc","active":"_9eecf","small":"_1131b","medium":"_0cd20","large":"_8d929","leftLabel":"_791da","rightLabel":"f1209"};